export const DATE_FORMAT = {
  PRIMARY: 'MMM D, YYYY',
  SECONDARY: 'MMMM YYYY',
  INFO: 'MMMM D, YYYY',
  VIRTUAL_CARD: 'MM/YY',
  MOVE_MONEY: 'MM/DD/YYYY',
  CHART: 'YYYY-MM-DD',
  BIRTHDAY: 'MM-DD-YYYY',
  FULL_FORMAT: 'dddd, MMMM D, YYYY h:mm A'
};

export const MONTH_LIMIT = 15;
export const DELAY_SHOW_ACTIVATE_CARD_IN_DAYS = 5;
